import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArtigoCssBuy from "../pages/artigo/o-que-e-cssbuy-spreadsheet/page";
import ArtigoComoUsar from "../pages/artigo/como-usar-cssbuy-spreadsheet-passo-a-passo/page";
import ArtigoConfiavel from "../pages/artigo/cssbuy-spreadsheet-e-confiavel/page";
import ArtigoMelhor from "../pages/artigo/melhor-cssbuy-spreadsheet-2026/page";
import ArtigoComparacao from "../pages/artigo/cssbuy-vs-pandabuy-vs-sugargoo/page";
import ArtigoEncontrar from "../pages/artigo/como-encontrar-produtos-cssbuy-spreadsheet/page";
import ArtigoErros from "../pages/artigo/erros-comuns-cssbuy-spreadsheet/page";
import ArtigoIniciantes from "../pages/artigo/guia-completo-cssbuy-iniciantes/page";
import ArtigoEconomizar from "../pages/artigo/como-economizar-cssbuy-spreadsheet/page";
import ArtigoRoupas from "../pages/artigo/cssbuy-spreadsheet-funciona-para-roupas/page";
import Blog from "../pages/blog/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/artigo/o-que-e-cssbuy-spreadsheet",
    element: <ArtigoCssBuy />,
  },
  {
    path: "/artigo/como-usar-cssbuy-spreadsheet-passo-a-passo",
    element: <ArtigoComoUsar />,
  },
  {
    path: "/artigo/cssbuy-spreadsheet-e-confiavel",
    element: <ArtigoConfiavel />,
  },
  {
    path: "/artigo/melhor-cssbuy-spreadsheet-2026",
    element: <ArtigoMelhor />,
  },
  {
    path: "/artigo/cssbuy-vs-pandabuy-vs-sugargoo",
    element: <ArtigoComparacao />,
  },
  {
    path: "/artigo/como-encontrar-produtos-cssbuy-spreadsheet",
    element: <ArtigoEncontrar />,
  },
  {
    path: "/artigo/erros-comuns-cssbuy-spreadsheet",
    element: <ArtigoErros />,
  },
  {
    path: "/artigo/guia-completo-cssbuy-iniciantes",
    element: <ArtigoIniciantes />,
  },
  {
    path: "/artigo/como-economizar-cssbuy-spreadsheet",
    element: <ArtigoEconomizar />,
  },
  {
    path: "/artigo/cssbuy-spreadsheet-funciona-para-roupas",
    element: <ArtigoRoupas />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;